export default function SchoolInfoRow({ label, value }) {
  return (
    <div className="sap-info-row">
      <span className="sap-info-label">{label}</span>
      <span className="sap-info-value">{value || '—'}</span>
    </div>
  );
}
